import type { Maintenance } from "@/hooks/useIncidentSummary";

/** Maintenance times, in the reader's own locale and time zone. */
const maintenanceTimeFormat = new Intl.DateTimeFormat(undefined, {
  weekday: "short",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  timeZoneName: "short",
});

export const formatMaintenanceTime = (isoTimestamp: string): string =>
  maintenanceTimeFormat.format(new Date(isoTimestamp));

/**
 * When a maintenance runs: its planned window while scheduled, its planned end once under way.
 * `null` when there is no time worth showing, including an end that has already passed.
 */
export const describeMaintenanceWindow = (
  {
    isUnderWay,
    startsAt,
    endsAt,
  }: Pick<Maintenance, "isUnderWay" | "startsAt" | "endsAt">,
  now: number = Date.now(),
): string | null => {
  if (isUnderWay) {
    return endsAt && Date.parse(endsAt) > now
      ? `Expected to end ${formatMaintenanceTime(endsAt)}`
      : null;
  }
  if (!startsAt) {
    return null;
  }
  const start = new Date(startsAt);
  const end = endsAt ? new Date(endsAt) : undefined;
  const range =
    end && end >= start
      ? maintenanceTimeFormat.formatRange(start, end)
      : maintenanceTimeFormat.format(start);
  return `Scheduled for ${range}`;
};
